const Types = {
  GET_FINANCES_SUCCESS: "GET_FINANCES_SUCCESS",
  GET_FINANCIAL_STATUS_SUCCESS: "GET_FINANCIAL_STATUS_SUCCESS",
  GET_STORE_TRANSACTIONS_SUCCESS: "GET_STORE_TRANSACTIONS_SUCCESS",
  FINANCIAL_LOADING: "FINANCIAL_LOADING",
};

export default Types;
